/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgNotIn = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M18.143 13.9V7h-1.736v5.164l1.736 1.736zM2.707 1.293 1.293 2.707 6 7.414v9.764h1.75V9.164l2.133 2.133v5.881h1.736v-4.145l9.674 9.674 1.414-1.414-20-20z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgNotIn as NotIn };
